
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_detail: false,
            loading: false,
            days: new Date(),
            select_day: new Date().getDate(),
            select_date: 0,
            data: [],
            data_detail: [],
            detail: [],
            color: ["#4676FF", "#FF9500"]
        }
    }
    async componentDidMount() {
        await this.getDay();
        await this.Get();
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            date: format_date(this.state.days, "yyyy-mm-dd", "en"),
        }
        let result = await GET(tokens, "v1/TH/job-repair/calenda/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data_detail: result.data });
        }
        this.setState({ loading: false });
    }
    getDay = () => {
        let firstIndex = new Date(this.state.days.setDate(1)).getDay();
        let lastDay = new Date(this.state.days.getFullYear(), this.state.days.getMonth() + 1, 0);
        let month = [];
        let week = [];
        let index = firstIndex;

        console.log(this.state.days)
        if (month.length === 0) {
            for (let j = 0; j < firstIndex; j++) {
                week.push("");
            }
        }
        for (let i = 0; i < lastDay.getDate(); i++) {
            week.push((i + 1).toString())
            index += 1;
            if (index === 7) {
                index = 0;
                month.push(week);
                week = [];
            }
        }
        if (week.length !== 7) {
            for (let i = week.length; i < 7; i++) {
                week.push("");
            }
            month.push(week);
        }
        this.setState({ data: month });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="ปฏิทินแจ้งซ่อม" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>ปฏิทินแจ้งซ่อม</b></h3>
                        </div>
                        <div className="card border-0 rounded-lg">
                            <div className="card-header bg-primary">
                                <div className="w-100 d-flex align-items-center justify-content-center text-white">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="p-2 pointer icon text-20"
                                            onClick={() => {
                                                let date = this.state.days;
                                                date.setMonth(date.getMonth() - 1);
                                                this.setState({ days: date, data: [] });
                                                setTimeout(() => {
                                                    this.getDay();
                                                    this.Get();
                                                }, 10);
                                            }}
                                        >{"\uf053"}</span>
                                        <h5 className="wpx-200 text-center">{format_date(this.state.days, "mmmm yyyy")}</h5>
                                        <span className="p-2 pointer icon text-20"
                                            onClick={() => {
                                                let date = this.state.days;
                                                date.setMonth(date.getMonth() + 1);
                                                this.setState({ days: date, data: [] });
                                                setTimeout(() => {
                                                    this.getDay();
                                                    this.Get();
                                                }, 10);
                                            }}
                                        >{"\uf054"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <div className="w-100">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="d-none d-md-table-row">
                                                <th className="text-center text-white" style={{ backgroundColor: "#ee7e73", width: "14.28%" }}>วันอาทิตย์</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#fadb67", width: "14.28%" }}>วันจันทร์</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#ee7589", width: "14.28%" }}>วันอังคาร</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#4d9641", width: "14.28%" }}>วันพุธ</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#f5b760", width: "14.28%" }}>วันพฤหัสบดี</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#83a0f8", width: "14.28%" }}>วันศุกร์</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#bd8be2", width: "14.28%" }}>วันเสาร์</th>
                                            </tr>
                                            <tr className="d-table-row d-md-none">
                                                <th className="text-center text-white" style={{ backgroundColor: "#ee7e73", width: "14.28%" }}>อา.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#fadb67", width: "14.28%" }}>จ.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#ee7589", width: "14.28%" }}>อ.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#4d9641", width: "14.28%" }}>พ.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#f5b760", width: "14.28%" }}>พฤ.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#83a0f8", width: "14.28%" }}>ศ.</th>
                                                <th className="text-center text-white" style={{ backgroundColor: "#bd8be2", width: "14.28%" }}>ส.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data && this.state.data.map((month, month_index) => (
                                                <tr key={month_index}>
                                                    {month.map((day, day_index) => (
                                                        <td className={this.state.select_day === Number(day) ? "text-end bg-primary-light" : "text-end"}>
                                                            <div
                                                                className="hpx-60 pointer"
                                                                onClick={() => {
                                                                    if (day !== "") {
                                                                        this.setState({
                                                                            modal_detail: true,
                                                                            select_day: Number(day),
                                                                            select_date: day_index,
                                                                            detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                        })
                                                                    }
                                                                }}>
                                                                <h4>{day}</h4>
                                                            </div>
                                                            <div
                                                                className="hpx-60 w-100 pointer align-items-end flex-wrap d-none d-lg-flex"
                                                                onClick={() => {
                                                                    if (day !== "") {
                                                                        this.setState({
                                                                            modal_detail: true,
                                                                            select_day: Number(day),
                                                                            select_date: day_index,
                                                                            detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                        })
                                                                    }
                                                                }}>
                                                                {this.state.data_detail
                                                                    .filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                    .map((item, index) => index < 2 ? (
                                                                        <div
                                                                            className="px-2 text-white text-12 rounded d-flex align-items-center me-1 text-nowrap"
                                                                            style={{ backgroundColor: this.state.color[index] }}
                                                                            onClick={() => {
                                                                                if (day !== "") {
                                                                                    this.setState({
                                                                                        modal_detail: true,
                                                                                        select_day: Number(day),
                                                                                        select_date: day_index,
                                                                                        detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                                    })
                                                                                }
                                                                            }}>
                                                                            {item.job}
                                                                        </div>
                                                                    ) : index === (this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day)).length - 1) ? (
                                                                        <div
                                                                            className="px-1 text-white text-12 rounded d-flex align-items-center me-1"
                                                                            style={{ backgroundColor: "#FF3B30" }}
                                                                            onClick={() => {
                                                                                if (day !== "") {
                                                                                    this.setState({
                                                                                        modal_detail: true,
                                                                                        select_day: Number(day),
                                                                                        select_date: day_index,
                                                                                        detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                                    })
                                                                                }
                                                                            }}>
                                                                            +{this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day)).length - 2}
                                                                        </div>
                                                                    ) : null)}
                                                            </div>
                                                            <div
                                                                className="hpx-30 w-100 pointer align-items-end flex-wrap d-flex d-lg-none d-xl-none d-xxl-none"
                                                                onClick={() => {
                                                                    if (day !== "") {
                                                                        this.setState({
                                                                            modal_detail: true,
                                                                            select_day: Number(day),
                                                                            select_date: day_index,
                                                                            detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                        })
                                                                    }
                                                                }}>
                                                                {this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day)).length !== 0 && (
                                                                    <div
                                                                        className="px-1 text-white text-12 rounded d-flex align-items-center me-1 ms-auto"
                                                                        style={{ backgroundColor: "#FF3B30" }}
                                                                        onClick={() => {
                                                                            if (day !== "") {
                                                                                this.setState({
                                                                                    modal_detail: true,
                                                                                    select_day: Number(day),
                                                                                    select_date: day_index,
                                                                                    detail: this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day))
                                                                                })
                                                                            }
                                                                        }}>
                                                                        +{this.state.data_detail.filter(item => Number(format_date(item.repair_date, "d")) === Number(day)).length}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* detail*/}
                <Modal show={this.state.modal_detail} onHide={() => { this.setState({ modal_detail: false }) }}>
                    <Modal.Body className="p-0">
                        <div className="w-100 p-2 text-center" style={{
                            borderTopLeftRadius: 12,
                            borderTopRightRadius: 12,
                            backgroundColor: this.state.select_date === 0 ? "#ee7e73" :
                                this.state.select_date === 1 ? "#fadb67" :
                                    this.state.select_date === 2 ? "#ee7589" :
                                        this.state.select_date === 3 ? "#4d9641" :
                                            this.state.select_date === 4 ? "#f5b760" :
                                                this.state.select_date === 5 ? "#83a0f8" :
                                                    this.state.select_date === 6 ? "#bd8be2" : ""
                        }}>
                            <h4 className="text-white">
                                <b>
                                    {this.state.select_date === 0 ? "วันอาทิตย์" :
                                        this.state.select_date === 1 ? "วันจันทร์" :
                                            this.state.select_date === 2 ? "วันอังคาร" :
                                                this.state.select_date === 3 ? "วันพุธ" :
                                                    this.state.select_date === 4 ? "วันพฤหัสบดี" :
                                                        this.state.select_date === 5 ? "วันศุกร์" :
                                                            this.state.select_date === 6 ? "วันเสาร์" : ""} {this.state.select_day} {format_date(this.state.days, "mmmm yyyy")}
                                </b>
                            </h4>
                        </div>
                        <div className="p-3">
                            <table className="table table-borderless table-hover">
                                <thead>
                                    <tr >
                                        <th className="text-center">รหัสการซ่อม</th>
                                        <th className="text-center">เลขทะเบียน</th>
                                        <th className="text-center">รุ่น</th>
                                        <th className="text-center">ยี่ห้อ</th>
                                        <th className="text-center">จัดการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.detail && this.state.detail.map((item, index) => (
                                            <tr key={index} className="border-bottom pointer">
                                                <td className="text-center">{item.job_number ? item.job_number : "-"}</td>
                                                <td className="text-center">{item.license_plate ? item.license_plate : "-"}</td>
                                                <td className="text-center">{item.model_name ? item.model_name : "-"}</td>
                                                <td className="text-center">{item.brand_name ? item.brand_name : "-"}</td>
                                                <td className="text-center" >
                                                    <div className="w-100 d-flex justify-content-center">

                                                        {item.job_status < 7 ? (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id }}>
                                                                <label className="pointer icon text-cyan p-2">{"\uf15b"}</label>
                                                            </div>
                                                        ) : (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id + "&type=read" }}>
                                                                <label className="pointer icon text-cyan p-2">{"\uf15b"}</label>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn btn-danger" onClick={() => { this.setState({ modal_detail: false }) }}>
                                ปิดหน้าต่าง
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
